import { render, staticRenderFns } from "./Monitor.vue?vue&type=template&id=1b52d044&scoped=true&"
import script from "./Monitor.vue?vue&type=script&lang=js&"
export * from "./Monitor.vue?vue&type=script&lang=js&"
import style0 from "./Monitor.vue?vue&type=style&index=0&id=1b52d044&lang=scss&scoped=true&"
import style1 from "./Monitor.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b52d044",
  null
  
)

export default component.exports